<template>
  <div>
    <div class="b-banner-con">
      <v-header></v-header>
      <v-nav></v-nav>
    </div>
    <v-breadcrumb></v-breadcrumb>
    <!-- 主题内容 -->
    <div class="b-center-container">
      <div class="b-container">
        <div class="b-center-main" style="padding: 60px;">
          <div class="title">
            科学普及
          </div>
          <div class="contentLeft">
            <ul class="leftNavigation">

              <li v-if="this.$route.query.category == 'hdyg'" class="clickable active"><a href="/sciences?category=hdyg"><i class="fa fa-caret-left leftNavIcon" aria-hidden="true"></i>活动预告</a></li>
              <li v-else class="clickable"><a href="/sciences?category=hdyg"><i class="fa fa-caret-left leftNavIcon" aria-hidden="true"></i>活动预告</a></li>

              <li v-if="this.$route.query.category == 'kpdt'" class="clickable active"><a href="/sciences?category=kpdt"><i class="fa fa-caret-right leftNavIcon" aria-hidden="true"></i>科普动态</a></li>
              <li v-else class="clickable"><a href="/sciences?category=kpdt"><i class="fa fa-caret-right leftNavIcon" aria-hidden="true"></i>科普动态</a></li>

              <li v-if="this.$route.query.category == 'kpzp'" class="clickable active"><a href="/sciences?category=kpzp"><i class="fa fa-caret-right leftNavIcon" aria-hidden="true"></i>科普作品</a></li>
              <li v-else class="clickable"><a href="/sciences?category=kpzp"><i class="fa fa-caret-right leftNavIcon" aria-hidden="true"></i>科普作品</a></li>

              <li v-if="this.$route.query.category == 'kpjt'" class="clickable active"><a href="/sciences?category=kpjt"><i class="fa fa-caret-right leftNavIcon" aria-hidden="true"></i>海上科普讲台 (大健康专题)</a></li>
              <li v-else class="clickable"><a href="/sciences?category=kpjt"><i class="fa fa-caret-right leftNavIcon" aria-hidden="true"></i>海上科普讲台 (大健康专题)</a></li>

              <li><a href="javascript:void(0);"><i class="fa fa-caret-right leftNavIcon" aria-hidden="true"></i>合作伙伴</a></li>
              <li v-for="item in hzhbList" :key="item">
                <a :href="item.url" target="_blank"><span style="margin-left: 30px;">{{ item.title }}</span></a>
              </li>
            </ul>
          </div>
          <p style="margin-left: 295px; margin-top: -50px; text-align: left; margin-bottom:40px"><span style="font-size: 22px; border-bottom: solid 3px #0c5cc8;">{{ categoryName }}</span></p>
<!--          <p style="text-align:left; margin-bottom:40px"><span style="margin-left: 36px; font-size: 16px;">转化医学国家重大科技基础设施（上海）作为集成性大科学平台，秉承着“开放共享”的服务理念，具有面向社会进行科学普及的义务。2019年转化医学闵行基地投入试运行以来，作为先试先行的典范，得到上级领导、政府机构、国内外高校、企业等多方关注。设施通过设立“设施开放日”，向社会公众传播健康知识、展示研究成果、传递科学正能量。 </span></p>-->
          <!-- 科学普及列表 -->
          <div class="b-newsList clearfix">
            <ul v-if="this.$route.query.category == 'kpjt'" class="clearfix">
              <li v-for="item in sliceNewsList" style="border: 1px solid #e8e8e8;"
                  :key="item">
                <a :href="'/detail?type=sciences&category=kpjt&id='+item.sciencesId" target="_blank"
                   class="b-item-link" style="height: 535px">
                  <div class="b-img">
                    <img :src="item.IP_URL + '/ueditor/images/zoomin_'+item.picture"
                         alt="img" style="height: 470px">
                    <div class="b-date">{{ item.publish_time }}</div>
                  </div>
                  <div class="b-item-name-2">{{ item.title }}</div>
                </a>
              </li>
            </ul>
            <ul v-else class="clearfix">
              <li v-for="item in sliceNewsList" style="border: 1px solid #e8e8e8;"
                  :key="item">
                <a :href="'/detail?type=sciences&id='+item.sciencesId" target="_blank"
                   class="b-item-link">
                  <div class="b-img">
                    <img :src="item.IP_URL + '/ueditor/images/zoomin_'+item.picture"
                         alt="img" height="262px">
                    <div class="b-date">{{ item.publish_time }}</div>
                  </div>
                  <div class="b-item-name">{{ item.title }}</div>
                </a>
              </li>
            </ul>
          </div>
          <p>&nbsp;</p>
          <el-pagination background
                         @current-change="handleCurrentChange"
                         layout="prev, pager, next"
                         :page-size="6"
                         :total="count">
          </el-pagination>
          <p>&nbsp;</p>
          <p>&nbsp;</p>
        </div>
      </div>
    </div>
    <v-contact></v-contact>
      <!--
      <v-footer></v-footer>
      <v-copy></v-copy>
      -->
  </div>
</template>
<script>
/* eslint-disable */
import Header from "@/components/header/";
import Nav from "@/components/nav/";
import Copy from "@/components/copy/"
import Breadcrumb from "@/components/breadcrumb/"
import Footer from "@/components/footer/"
import Contact from "@/components/contact/";
import $ from "jquery";
export default {
  methods: {
    handleCurrentChange(val) {
      this.currentPage = val;
      this.sliceNewsList = this.newsList.slice((this.currentPage-1) * this.pageSize, this.currentPage * this.pageSize);
      for(var i=0;i < this.sliceNewsList.length; i++){
        this.sliceNewsList[i].publish_time = this.sliceNewsList[i].publish_time.substring(0,10);
      }
      console.log(`当前页: ${val}`);
    }
  },

  data () {
    return {
      pageSize: 6,
      newsList: [],
      count:0,
      sliceNewsList: [],
      categoryName: '',
      hzhbList: []
    };
  },
  mounted () {

    // 科学普及列表
    //为了在内部函数能使用外部函数的this对象，要给它赋值了一个名叫self的变量。
    var self = this;
    var category = self.$route.query.category
    if (category == 'hdyg')
      self.categoryName = '活动预告';
    else if (category == 'kpdt')
      self.categoryName = '科普动态';
    else if (category == 'kpzp')
      self.categoryName = '科普作品';
    else if (category == 'kpjt')
      self.categoryName = '海上科普讲台 (大健康专题)';

    $.ajax({
      url:  Header.IP_URL + '/sciences/simpleList?category=' + category,
      type: 'get',
      // data: {},
      dataType: 'json'
    }).then(function (res) {
      console.log(res);
      //把从json获取的数据赋值给数组
      self.newsList = res.data;
      self.count = res.count;
      self.sliceNewsList = self.newsList.slice(0, self.pageSize);
      for(var i=0;i < self.sliceNewsList.length; i++){
        self.sliceNewsList[i].publish_time = self.sliceNewsList[i].publish_time.substring(0,10);
      }
      for(var i=0;i < self.newsList.length; i++){
        self.newsList[i].IP_URL = Header.IP_URL;
      }
    }).fail(function () {
      console.log('失败');
    });

    $.ajax({
      url:  Header.IP_URL + '/sciences/simpleList?category=hzhb' ,
      type: 'get',
      // data: {},
      dataType: 'json'
    }).then(function (res) {
      console.log(res);
      //把从json获取的数据赋值给数组
      self.hzhbList = res.data;
    }).fail(function () {
      console.log('失败');
    });
  },
  components: {
    "v-header": Header,
    "v-nav": Nav,
    "v-copy": Copy,
    "v-breadcrumb": Breadcrumb,
    "v-footer": Footer,
    "v-contact": Contact,
  }
};
</script>
<style lang="scss" scoped>
  @media screen and (max-width:600px) {
	.b-banner-con{
	    //padding: 22px 0;
	    background: url(../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
	    width: 1440px;
	}
  }

  @media screen and (min-width:960px) {
    .b-banner-con{
	    //padding: 22px 0;
	    background: url(../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
    }
  }

/* 科学普及列表 */
.b-newsList ul {
  margin: 0 -10px;
  margin-bottom: 40px;
  //height: -webkit-fill-available;
  display: flex;
  flex-wrap: wrap;
  li {
    width: (100% / 3);
    float:left;
    //margin: 0 0 15px 0;
    .b-item-link {
      //margin: 0 8px;
      display: block;
      height: 305px;
      overflow: hidden;
    }
    .b-img {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto;
      position: relative;
      img {
        width: 100%;
        height: 262px;
      }
      .b-date {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 40%;
        -webkit-transition: all 0.3s ease-in-out;
        transition: all 0.3s ease-in-out;
        -dm-stylegroup: on;
        background-color: #9cc3f5;
        color: #fff;
        font-family: microsoft yahei;
        font-size: 12px;
        line-height: 35px;
        text-align: right;
        padding-right: 10px;
        &:hover {
          width: 100%;
          background-color: #0c5cc8;
        }
      }
    }
    .b-item-name {
      text-align: left;
      color: rgb(128, 128, 128);
      font-size: 14px;
      /* font-weight: bold; */
      height: 25px;
      line-height: 25px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      word-break: break-all;
      margin-top: 10px;
      margin-left: 10px;
      margin-right: 10px;
      //margin-top: 10px;
      &:hover {
        color: #0c5cc8;
        text-decoration: none;
        cursor: pointer;
      }
    }
    .b-item-name-2 {
      text-align: left;
      color: rgb(128, 128, 128);
      font-size: 14px;
      /* font-weight: bold; */
      height: 25px;
      line-height: 25px;
     // overflow: hidden;
      display:-webkit-box;
      -webkit-line-clamp:2;
      -webkit-box-orient:vertical;
      text-overflow: ellipsis;
      margin-top: 10px;
      margin-left: 10px;
      margin-right: 10px;
      //margin-top: 10px;
      &:hover {
        color: #0c5cc8;
        text-decoration: none;
        cursor: pointer;
      }
    }
    .b-item-des {
      text-align: left;
      color: #666;
      font-size: 12px;
      line-height: 20px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      word-break: break-all;
      overflow: hidden;
    }
  }
}

  ///////////////
  .title {
    width: 230px;
    margin-bottom: 0px;
    position: relative;
    padding: 10px 15px 11px;
    background: #0c5cc8;
    font-size: 22px;
    font-weight: 500;
    color:#ffffff;
    text-transform:uppercase;
  }
  .contentLeft {
    width: 230px;
    float: left;
    margin-right: 60px;
    top: 0;
    left: 0;
    background-color: #f2f7ff;
  }

  .contentRight {
    padding: 1.3rem 2rem;
    margin-left: 250px;
  }

  .leftNavigation {
    margin: 0rem 0;
  }
  .leftNavigation li {
    border-bottom: solid 1px #c6dbf5;
    border-right: solid 1px #c6dbf5;
    text-align: left;
  }
  .leftNavigation, .leftNavigation li ul {
    list-style: none;
    padding: 0;
  }
  .leftNavigation li a {
    font-size: 16px;
    display: block;
    padding: 10px 10px 10px 20px;
    color: #1f1f1f;
    /*border-bottom: solid 1px #1e76b8;*/
    text-overflow: ellipsis;
    overflow: hidden;
    position: relative;
    -webkit-transition: color 0.2s ease;
    transition: color 0.2s ease;
    font-weight:400;border-left: #c6dbf5 solid 5px;
    border-right: #c6dbf5 solid 5px;
  }
  .leftNavigation li a, .leftNavigation li a .leftNavIcon {
    line-height: 160%;
  }
  .leftNavigation li a .leftNavIcon {
    position: absolute;
    top: 0;
    left: -1px;
    /*width: 3rem;*/
    padding: 6px 0;
    text-align: center;
    font-weight:100;color: #f2f7ff;font-size: 20px;
  }
  .leftNavigation li.active a .leftNavIcon {color: #7396c3;}
  .leftNavigation li a .leftNavIcon1 {
    position: absolute;
    top: 0;
    left: 0;
    width: 4rem;
    padding: 0.8rem 0;
    text-align: center;
  }
  .leftNavigation li a:hover {
    color: #142e8f; text-decoration:none; background:#d6e7fd;
    border-left: #7396c3 solid 5px;
    border-right: #7396c3 solid 5px;
  }
  .leftNavigation li a:hover .leftNavIcon {color: #7396c3;}
  .leftNavigation li ul {
    /*display: none;*/
    margin: 0;border-top: solid 1px #c6dbf5;border-left: #c6dbf5 solid 5px;padding: 8px 0;
  }
  .leftNavigation li ul li { border-bottom: solid 0px #1e76b8;}
  .leftNavigation li ul li a {
    border: 0px; font-size:13px; color:#383838; background:url(../../assets/img/csu_ico_17.gif) no-repeat 30px 10px;padding: 5px 15px 5px 48px;border-left: 0;
  }
  .leftNavigation li ul li a:hover {
    background:url(../../assets/img/csu_ico_17.gif) no-repeat 30px 10px;color:#142e8f;text-decoration:none;border: 0;
  }
  /*#

   li ul li:last-child a {
    border-bottom: none;
  }*/
  .leftNavigation li ul li.active a {
    color: #8bebff; text-decoration:none;
  }
  .leftNavigation li.active > a {
    color: #142e8f; text-decoration:none;
    border-left: #7396c3 solid 5px;
    border-right: #7396c3 solid 5px;
  }
  .leftNavigation li.active ul {
    display: block;border-top: solid 1px #1e76b8;
  }
  .leftNavigation > li.active {
    background-color: #d6e7fd;
  }
  .leftNavigation li ul li .level4 {border-top: solid 1px #1e76b8;}
  .leftNavigation li ul li .level4 li a {
    border-bottom: solid 0px #D0E9F3; font-size:14px; color:#e2f5fa; padding-left:42px;background: transparent;border-left: #2473c0 solid 5px;
  }
  .leftNavigation li ul li .level4 li a:hover {color: #8bebff;}
  .leftNavigation li ul li .level4 li {border-bottom: solid 1px #1e76b8;}
  .leftNavigation li ul li .level4 li:last-child {border-bottom: solid 0px #D0E9F3;}
</style>



// WEBPACK FOOTER //
// src/pages/sciences/index.vue